import React from 'react';
import InternalConversation from './InternalConversation';
import SharedWithTableComponent from './SharedWithTableComponent';
import ExternalComments from './ExternalComments';

const ActivityModalView = props => {
  return {
    internalConversation: <InternalConversation {...props} />,
    sharedLog: <SharedWithTableComponent {...props} />,
    externalComments: <ExternalComments {...props} />,
  };
};

export default ActivityModalView;
